<template lang="pug">
  form(@submit.prevent="navigate('sistema.docModelos.edit.reincidencia')")
    p.text-large  - Informe as Regras de Cálculo do Modelo
    .columns
      .column.col-6.col-md-8.col-sm-12
        .columns
          .column.col-12
            form-group(label="Coluna de cálculo" :validation="$v.resource.params.osm.calculo.tipo_valor_parametro")
              select.form-select(v-model="$v.resource.params.osm.calculo.tipo_valor_parametro.$model")
                option(value="" v-if="!temRegras && !temGrauDeInfracoes") Não informar
                option(value="area" v-if='!temGrauDeInfracoes') Área
                option(value="tamanho_testada" v-if='!temGrauDeInfracoes') Tamanho da testada
                option(value="determinado" v-if="!temRegras && !temGrauDeInfracoes") Determinado
                option(value="soma_de_irregularidades" v-if="!temRegras && !temGrauDeInfracoes") Soma de irregularidades
                option(value="grau_de_infracao" v-if="!temRegras") Grau de infração
              .form-input-hint
                span Coluna que será utilizada para efetuar o cálculo
          .column.col-12(v-if="resource.params.osm.calculo.tipo_valor_parametro === 'area'")
            .form-group
              label.form-switch
                input(type="checkbox" v-model="resource.params.osm.calculo.buscar_area_do_cadastro")
                i.form-icon
                |  Utilizar a área definida no cadastro
    .mt-2(v-if="showRegras")
      h1.h5 Regras de cálculo
      doc-regras-calculo(v-model="$v.resource.params.osm.calculo.regras.$model" :validation="$v.resource")
      .mt-2(v-if="!$v.resource.params.osm.calculo.regras.ultimoParametro")
        .divider
        span.text-warning - O parametro final da última regra deve ser 9.999.999.999,99!&nbsp;
        a.text-small.c-hand(@click="fixUltimoParametro") Clique aqui para corrigir
    .mt-2(v-if="resource.params.osm.calculo.tipo_valor_parametro === 'grau_de_infracao'")
      h1.h5 Graus de infrações
      grau-infracoes(v-model="$v.resource.params.osm.calculo.grau_de_infracoes.$model" :validation="$v.resource")
    .py-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import { deepKey } from 'paliari-js-utils'
import editMixin from './mixin'
import { PARAMETRO_MAXIMO } from '@/models/DocCalculoRegra'
import GrauInfracoes from '../components/GrauInfracoes/Component'

// Validador customizado que garante que o último valor será o PARAMETRO_MAXIMO
const ultimoParametro = (value = []) => {
  const lastValue = value[value.length - 1]
  if (!lastValue) return true

  return lastValue.parametro_final === PARAMETRO_MAXIMO
}

export default {
  mixins: [editMixin],
  components: { GrauInfracoes },
  methods: {
    fixUltimoParametro() {
      this.resource.params.osm.calculo.regras[
        this.resource.params.osm.calculo.regras.length - 1
      ].parametro_final = PARAMETRO_MAXIMO
    },
  },
  computed: {
    showRegras() {
      const parametro = deepKey(
        this.resource,
        'params.osm.calculo.tipo_valor_parametro',
      )

      return parametro && ['area', 'tamanho_testada'].includes(parametro)
    },
    temRegras() {
      const regras = deepKey(this.resource, 'params.osm.calculo.regras')

      return regras && regras.length > 0
    },
    temGrauDeInfracoes() {
      const grauInfracoes = deepKey(
        this.resource,
        'params.osm.calculo.grau_de_infracoes',
      )

      return grauInfracoes && grauInfracoes.length > 0
    },
  },
  validations() {
    return {
      resource: {
        params: {
          osm: {
            calculo: {
              tipo_valor_parametro: {},
              grau_de_infracoes: {},
              regras: {
                ultimoParametro,
                $each: {
                  parametro_inicial: {
                    required,
                    minValue: minValue(0),
                    maxValue: maxValue(PARAMETRO_MAXIMO - 0.01),
                  },
                  parametro_final: {
                    required,
                    minValue: minValue(0),
                    maxValue: maxValue(PARAMETRO_MAXIMO),
                  },
                },
              },
            },
          },
        },
      },
    }
  },
}
</script>
